import { primitiveTokens } from "@appretio/ui-kit";
import { style } from "@vanilla-extract/css";

export const contentContainer = style({
  padding: `${primitiveTokens.sizing["4x"]} 0`,
  width: "75vw",
  maxHeight: "90vh",
  overflowY: "auto"
});

export const tableContainer = style({
  height: "80vh",
  borderRadius: primitiveTokens.radii["md"],
  overflow: "hidden"
});

export const cubeNote = style({
  marginBottom: primitiveTokens.sizing["4x"]
});

export const spinnerContainer = style({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  transform: "scale(3)"
});
